
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinpune() {



const cardData =
{
  keyword: 'Corporate Cab Service in Pune Airport',
  heading: 'eTravo: Corporate Cab Service in Pune Airport',
  headingDescription: 'eTravo offers professional, on-time, and comfortable corporate cab services for Pune Airport transfers. Whether you are welcoming a high-profile client, sending staff to a business trip, or managing routine corporate airport transport, our fleet of AC cabs ensures premium service with GPS tracking, courteous drivers, and 24/7 availability. We cater to both one-time bookings and monthly travel contracts, offering customized solutions for HR and admin teams handling corporate mobility. Trust eTravo for seamless airport pickups and drop-offs for executives, staff, and business visitors in Pune.',

  top: 'Top Locations Around Pune Airport for Corporate Travel',
  topPlaces: [
    {
      title: 'Pune International Airport (Lohegaon)',
      description: 'The hub of corporate flight traffic in Pune, handling thousands of business travelers daily. eTravo’s airport cab services operate 24x7 here, ensuring reliable pickup and drop-off for corporate employees, managers, and VIP guests. Our drivers are trained for airport etiquette, timely tracking of flight arrivals, and professional client handling.'
    },
    {
      title: 'Viman Nagar',
      description: 'A prime residential and commercial area located just 2 km from the airport. Popular among company executives and visiting clients, Viman Nagar hosts several business hotels and co-working spaces. eTravo offers frequent airport transfers to and from this locality with clean, well-maintained AC cabs.'
    },
    {
      title: 'Yerwada',
      description: 'Home to several business parks and hotel chains like The Ritz-Carlton, Yerwada is a corporate hotspot close to Pune Airport. Our services include daily cab contracts for executives, early morning airport drops, and VIP pickups in Innova Crysta or sedan-class vehicles.'
    },
    {
      title: 'Kalyani Nagar',
      description: 'A premium commercial area just a short drive from the airport, known for its business lounges, cafes, and meeting venues. Our cabs frequently serve this area for client pickups and intercity airport transfers, especially for corporate guests staying in 4–5 star hotels.'
    },
    {
      title: 'Koregaon Park Annexe',
      description: 'Located near Viman Nagar, this area houses luxury serviced apartments, boutique offices, and business retreats. eTravo cabs ensure punctual pickup and drop for high-ranking officials traveling through Pune Airport.'
    },
    {
      title: 'Bund Garden Road',
      description: 'A strategic business location leading to major parts of central Pune. Many corporate offices use our monthly cab plans to manage airport commutes for frequent fliers and partner consultants visiting their Pune branches.'
    },
    {
      title: 'Hadapsar',
      description: 'Though farther from the airport, Hadapsar is home to large corporate zones like Magarpatta and Amanora. Our long-distance airport cab services ensure timely reporting, even during night shifts or peak business hours.'
    },
    {
      title: 'Shivajinagar',
      description: 'Known for government offices, courts, and engineering consultancies, Shivajinagar requires dependable transport for airport-bound corporate professionals. Our services here include early-morning executive drops and high-volume weekend travel logistics.'
    },
    {
      title: 'Pune Railway Station (Bund Garden Area)',
      description: 'eTravo bridges airport and rail travel for companies whose guests arrive via train. We offer combo pickup options, where executives are collected from the station and escorted to the airport via safe, sanitized cabs.'
    },
    {
      title: 'Kharadi',
      description: 'Though known for its tech parks, Kharadi is also a major source of airport-bound corporate travelers. Our daily cab services for this area cater to bulk airport drop schedules, especially during morning and evening peak hours.'
    }
  ],

  services: [
    {
      name: 'Pune Airport Corporate Cab Hire',
      description: 'Get premium cab rentals with experienced chauffeurs for all your corporate airport travel needs in Pune. Whether it’s a last-minute business trip or scheduled arrival of a visiting dignitary, our service ensures class, punctuality, and professionalism with every ride.'
    },
    {
      name: 'Airport Pickup and Drop for Corporates Pune',
      description: 'We specialize in managing airport pickups and drop-offs for entire teams, senior management, or external partners. Our drivers wait at arrivals with placards, monitor flight statuses in real-time, and maintain courteous conduct throughout the journey.'
    },
    {
      name: 'Executive Airport Cab Service Pune',
      description: 'For CXOs, directors, and VIP clients, we offer a fleet of premium vehicles including Innova Crysta, sedans, and luxury SUVs. These cabs are equipped with plush seating, climate control, and bottled water to enhance passenger experience.'
    },
    {
      name: 'Corporate Employee Airport Transport Pune',
      description: 'We offer bulk cab arrangements for employee airport travel needs—be it onboarding new recruits or transporting support staff post night shift. All rides are logged, monitored, and optimized for cost-efficiency and safety.'
    },
    {
      name: 'Reliable Airport Cab Services Pune',
      description: 'Known for our punctuality and trip accuracy, eTravo ensures that no employee or executive ever misses a flight. Our cabs undergo daily checks and our support team is available round-the-clock for emergency route changes or reschedules.'
    },
    {
      name: 'Airport Shuttle Service Pune',
      description: 'We provide exclusive shuttle services for companies managing frequent group travel. Perfect for seminars, training batches, or visiting delegates, this service offers great value with consistent service quality.'
    },
    {
      name: 'Business Travel Cab Pune',
      description: 'Ideal for one-way or round-trip airport business travel, this service is designed for startups, SMBs, and MNCs alike. Our plans include instant booking, scheduled rides, and invoice-ready trip reports for easier accounting.'
    },
    {
      name: 'Airport Transfer for Staff Pune',
      description: 'Affordable and dependable transport for entry- and mid-level staff traveling to or from Pune Airport. Our team coordinates pickup points, shift timing alignments, and emergency helplines to reduce operational friction for HR/admin teams.'
    },
    {
      name: 'Corporate Taxi Service Pune',
      description: 'Book professional taxi services with uniformed drivers and premium customer support. Our airport taxis operate city-wide with options to accommodate sudden demand spikes during conferences or corporate events.'
    },
    {
      name: 'Monthly Airport Cab Service Pune',
      description: 'For frequent fliers in your organization, we offer fixed monthly cab plans with predictable pricing, priority dispatch, and usage-based invoicing. Perfect for companies that require structured airport mobility without constant coordination.'
    },
    {
      name: 'Airport Transfer Solutions Pune',
      description: 'Customizable end-to-end airport mobility services including cab fleet setup, employee tracking, cost control, and booking integration with your corporate dashboard.'
    },
    {
      name: 'Comfortable Airport Ride Pune',
      description: 'Each cab is maintained to provide a comfortable and smooth ride experience, complete with cushioned seating, soft suspension, and calming interiors—ideal for post-flight fatigue or pre-meeting preparation.'
    }
  ],

  tableData: [
    ['Pune Airport Corporate Cab Hire', 'Airport Pickup and Drop for Corporates Pune'],
    ['Executive Airport Cab Service Pune', 'Corporate Employee Airport Transport Pune'],
    ['Reliable Airport Cab Services Pune', 'Airport Shuttle Service Pune'],
    ['Business Travel Cab Pune', 'Airport Transfer for Staff Pune'],
    ['Corporate Taxi Service Pune', 'Monthly Airport Cab Service Pune'],
    ['Airport Transfer Solutions Pune', 'Comfortable Airport Ride Pune']
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Airport Transfers for Corporate Travelers",
        "WhyChoosedescription": "eTravo provides punctual and comfortable cab services to and from Pune Airport, tailored specifically for corporate clients. Whether it’s an early morning flight or a late-night arrival, we ensure timely pickups and drops for executives and teams."
    },
    {
        "WhyChooseheading": "Wide Range of Business-Class Vehicles",
        "WhyChoosedescription": "Choose from premium sedans, SUVs, and MPVs like Innova Crysta based on your company’s preferences. All vehicles are clean, air-conditioned, and equipped for executive comfort."
    },
    {
        "WhyChooseheading": "Meet-and-Greet Services at Pune Airport",
        "WhyChoosedescription": "Our professional drivers offer meet-and-greet service with placards inside the airport terminal to ensure smooth and hassle-free reception of clients, guests, or senior management."
    },
    {
        "WhyChooseheading": "Flight Monitoring and Delay Handling",
        "WhyChoosedescription": "We track flight statuses in real-time to adjust cab timings in case of delays, cancellations, or early landings—ensuring your pickup schedules stay on track without needing constant follow-ups."
    },
    {
        "WhyChooseheading": "Priority Pickup for Corporate Bookings",
        "WhyChoosedescription": "Corporate bookings get access to priority scheduling, ensuring minimal wait times at the airport. Vehicles are dispatched in advance and tracked to avoid any last-minute delays."
    },
    {
        "WhyChooseheading": "24/7 Service Availability for Business Travelers",
        "WhyChoosedescription": "Pune Airport operates round the clock, and so do we. Our cab services are available 24/7, including weekends and holidays, to accommodate all corporate travel schedules."
    },
    {
        "WhyChooseheading": "Safe, Sanitized, and GPS-Enabled Fleet",
        "WhyChoosedescription": "All vehicles undergo regular sanitization and come equipped with GPS tracking, seat belts, first aid kits, and professional drivers trained in safety protocols."
    },
    {
        "WhyChooseheading": "Corporate Billing, Invoicing, and Account Management",
        "WhyChoosedescription": "We offer GST-compliant billing, itemized invoices, and account manager support for seamless management of your company’s airport transportation expenses."
    }
]
}


const faqData = [
    [
        {
            question: 'Does eTravo provide airport pickups for early morning or late-night flights?',
            answer: 'Yes, our corporate cab services operate 24/7, making it ideal for flights at any time of day or night from Pune Airport.'
        },
        {
            question: 'What types of vehicles are available for airport transport?',
            answer: 'We provide sedans, SUVs, and MPVs including Dzire, Honda City, Innova, and Innova Crysta—suited for individual and group airport transfers.'
        },
        {
            question: 'Can you provide meet-and-greet service at the terminal?',
            answer: 'Absolutely. Our drivers offer meet-and-greet with placards for executives and guests at both domestic and international arrivals.'
        },
        {
            question: 'Is flight tracking included in your airport cab service?',
            answer: 'Yes, we monitor flight status in real time to ensure that your cab is dispatched based on actual arrival or departure timings.'
        },
        {
            question: 'Do you offer monthly invoicing for regular airport travel?',
            answer: 'Yes, we offer monthly invoicing and detailed transport records with GST compliance for businesses that use our service regularly.'
        },
        {
            question: 'Will there be a dedicated point of contact for our company?',
            answer: 'Yes, each corporate client is assigned a dedicated account manager to handle scheduling, emergency support, and billing queries.'
        }
    ]
];


const testimonialsData = [
    {
        name: 'Mr. Prashant Vaidya',
        designation: 'Admin Manager, Novatek Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s airport pickup service for our executives is always on time. The drivers are courteous and know exactly where to wait, which helps us maintain our professional image.”'
    },
    {
        name: 'Ms. Priyanka Sawant',
        designation: 'Executive Assistant, Omicron Group',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo for all our guest airport transfers. Their team tracks flights, provides updates, and never misses a beat. Highly reliable for corporate use.”'
    }
];














    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Pune Airport",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-service-pune-airport.jpg",
  "description": "Book corporate cab service at Pune Airport with eTravo. Get reliable and comfortable airport pickup and drop for employees, executives, and business travelers. Choose AC cabs, on-time service, and monthly packages for corporate transport.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6249"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-service-pune-airport"
  }
};





    return (
        <div>

<Helmet>
  <title>Corporate Cab Service in Pune Airport | Executive Pickup & Drop | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cabs at Pune Airport for executive travel, staff pickups, and business transport. eTravo offers AC airport transfers, reliable drivers, and monthly plans for companies." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/39.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinpune;